import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useGetActiveVouchers = () => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });

		const res = await instance.get("/vouchers");
		return res.data?.data;
	};
	return useQuery(["vouchers"], () => fetch(), {
		...fetchConfig,
	});
};

export default useGetActiveVouchers;
